import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from "axios";
import { setupAxios } from "./helpers/Utils";
import store from './store';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30000,
            retry: 2,
            retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000),
            refetchOnWindowFocus: false,
        },
    },
});

setupAxios(axios, store);

// This handler prevents the browser "Unhandled rejection" crash for chains that lack .catch().
window.addEventListener('unhandledrejection', (event) => {
    // eslint-disable-next-line no-console
    event.preventDefault();
});

const _onerrorCounts = new Map();
window.onerror = (msg, src, lineno, colno, err) => {
    const key = `${msg}|${src}|${lineno}`;
    const count = (_onerrorCounts.get(key) ?? 0) + 1;
    _onerrorCounts.set(key, count);
    if (count === 1) setTimeout(() => _onerrorCounts.delete(key), 10000);
    if (count > 5) return true;
    // eslint-disable-next-line no-console
};

const app = (
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
